<!--
 * @Descripttion:
 * @version: 1.0
 * @Author: Li Lingao
 * @Date: 2020-08-20 17:31:39
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-09-17 18:26:38
-->
<template>
  <div class="left-chart-1">
    <div class="lc1-header"></div>
    <dv-border-box-13>
      <dv-decoration-7 style="width:150px;height:30px;font-size:18px;">事项类型统计</dv-decoration-7>
      <div class="lc1-details">
        事项总数
        <span>{{totalNum}}</span>
      </div>
      <dv-capsule-chart class="lc1-chart" :config="config" />
    </dv-border-box-13>
    <dv-decoration-2 style="height:10px;padding-top:0px;" />
  </div>
</template>

<script>
import ns from "@/services/NetService.js"
export default {
  name: 'LeftChart11',
  data() {
    return {
      config: {
        data: [],
        showValue: true
      },
      totalNum: 0
    }
  },
  methods: {
    init() {
      // ns.post('/getOperationData', {
      //   key: 'TYPE_ANALYSIS_QD',
      // }).then((res) => {
      //   let list = res.data[0].ANALYSIS_VALUE
      //   let num = 0
      //   for (let i = 0; i < list.length; i++) {
      //     num += list[i].value
      //   }
      //   this.config = { data: list, showValue: true }
      //   this.totalNum = num

      // }).catch(err => {
      //   console.error(err)
      // })
      this.config = {
        data: [{ name: '行政强制', value: 182 }, { name: '行政奖励', value: 110 }, { name: '行政征收', value: 15 }, { name: '行政处罚', value: 4396 }, { name: '公共服务', value: 434 }, { name: '行政给付', value: 19 }, { name: '行政裁决', value: 10 }, { name: '行政检查', value: 548 }, { name: '其他行政权力', value: 502 }, { name: '行政确认', value: 101 }, { name: '行政许可', value: 857 }], showValue: true
      }
      let num = 0
      let list = this.config.data
      for (let i = 0; i < list.length; i++) {
        num += list[i].value
      }
      this.totalNum = num
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="less">
.left-chart-1 {
  width: 100%;
  height: 90%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;

  .lc1-header {
    text-align: center;
    padding-top: 0px;
    height: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-bottom: 20px;
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc1-chart {
    flex: 1;
    color: #000;
  }
}
</style>
